import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/shared/Modal';
import ChangePasswordForm from './ChangePasswordForm';

const ChangePassword = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <>
      <button
        type="button"
        onClick={open}
        className={`inline-flex items-center justify-center rounded-lg px-4 py-2 text-white bg-[var(--feel-primary)] hover:opacity-90 focus:outline-none focus:ring-4 focus:ring-[var(--feel-primary)] transition`}
      >
        {t('PROVIDERS.changePassword')}
      </button>

      <Modal isOpen={isOpen} onClose={close} title={t('PROVIDERS.changePassword')}>
        <div className="p-6">
          <ChangePasswordForm onClose={close} />
        </div>
      </Modal>
    </>
  );
};

export default ChangePassword;
